import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { BehaviorSubject } from 'rxjs';
import { Apps } from 'src/app/shared/enums/enums';
import { Permission, UserPermissions } from 'src/app/shared/models/shared.models';
import { SharedService } from 'src/app/shared/services/shared.service';

@Injectable({
  providedIn: 'root',
})
export class MasterService {
  private permissionsSubject = new BehaviorSubject<any[]>([]);
  public permissions$ = this.permissionsSubject.asObservable();

  permissions: Permission[] = [];
  userRoles: UserPermissions[] = [];
  private readonly logoutEventKey = 'logout-event';
  constructor(
    private route: Router,
    private sharedService: SharedService,
  ) {}

  getUserDetailFromStorage() {
    return JSON.parse(localStorage.getItem('user')!);
  }

  decodeJwt(token: string): any {
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken;
    } catch (error) {
      console.error('Invalid token', error);
      return null;
    }
  }

  getUserInfo(token: string): any {
    const decodedToken = this.decodeJwt(token);
    if (decodedToken) {
      const userId = decodedToken.userId;
      const role = decodedToken.role;
      return { userId, role };
    }
    return null;
  }

  public userPermissions: any[] | null = null;
  public rolesLoaded = false;

  async getRolesandPerm(appId: number): Promise<any[]> {
    try {
      if (this.rolesLoaded && this.userPermissions) {
        return this.userPermissions;
      }
      const userData = this.getUserDetailFromStorage();
      if (userData) {
        const data = await this.sharedService.getPermissionsByUserId(userData.userid).toPromise();
        if (data) {
          this.userRoles = data as UserPermissions[];
          const appRoles = this.userRoles?.filter(
            (role) => role.appId === appId || role.appId === Apps.TPM || role.appId === Apps.POS,
          );
          const userPermissions: Permission[] = [];
          appRoles?.forEach((role) => {
            userPermissions.push(...role.permissions);
          });

          this.userPermissions = userPermissions;
          this.rolesLoaded = true;

          this.permissionsSubject.next(userPermissions);
          return userPermissions;
        }
      }
    } catch (error) {
      console.error('Error fetching permissions:', error);
    }

    return [];
  }

  //logout functionallity
  logout(): void {
    // Clear all authentication data
    // localStorage.clear();
    // sessionStorage.clear();
    // document.cookie = '';

    // Broadcast logout to other tabs
    //  localStorage.setItem(this.logoutEventKey, Date.now().toString());
    // Redirect to login page
    //this.router.navigate(['/login']);
    this.listenToLogoutEvents();
  }

  listenToLogoutEvents(): void {
    window.addEventListener('storage', (event) => {
      if (event.key === this.logoutEventKey) {
        this.handleExternalLogout();
      }
    });
  }

  private handleExternalLogout(): void {
    this.sharedService.performFullSessionCleanup();
    window.location.href = '/shared/login';
  }
}
